import React, { createContext, useState, useContext } from "react";

export const LeadsContext = createContext();

export function LeadsProvider({ children }) {
  const [leadsCount, setLeadsCount] = useState(0);

  const updateLeadsCount = (newCount) => {
    if (typeof newCount === "function") {
      setLeadsCount(newCount);
    } else {
      setLeadsCount(newCount);
    }
  };

  return (
    <LeadsContext.Provider value={{ leadsCount, updateLeadsCount }}>
      {children}
    </LeadsContext.Provider>
  );
}

export function useLeads() {
  const context = useContext(LeadsContext);
  if (!context) {
    throw new Error("useLeads deve essere usato all'interno di LeadsProvider");
  }
  return context;
}
